module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "weui-grids margin-top-thirdly"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tab-bar'), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "column-content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon_rounded_256.png"),
      "alt": "logo",
      "width": "40px",
      "height": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-brand primary",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n        易退税\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("退税就是这么简单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "how-to"
  }, [_c('div', {
    staticClass: "company"
  }, [_vm._v("\n      Safety Tax Free\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title-h2 head"
  }, [_vm._v("\n      完成退税，只需三步\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "img-shop"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-h1"
  }, [_vm._v("\n        01. 购物时领取税单\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("在商店购物付款时请领取易退税退税单。复查确保您的个人资料完整齐全。")]), _vm._v(" "), _c('p', [_vm._v("姓名，国家以及护照号码是必填信息。")]), _vm._v(" "), _c('p', [_vm._v("使用易退税APP扫描退税单上的二维码进行"), _c('strong', [_vm._v("绑定")]), _vm._v("以及"), _c('strong', [_vm._v("上传小票照片")]), _vm._v("。")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "img-stamp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-h1"
  }, [_vm._v("\n        02. 海关盖章\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("在最后离开欧洲前，请至机场海关完成退税单盖章。")]), _vm._v(" "), _c('p', [_vm._v("如果退税单上无海关盖章将无法完成退税。")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "img-delivery"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-h1"
  }, [_vm._v("\n        03. 回国后预约顺丰收单\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("回国后请使用顺丰速运"), _c('strong', [_vm._v("隔日达到付")]), _vm._v("服务将"), _c('strong', [_vm._v("税单及小票")]), _vm._v("邮寄至北京收单中心。")]), _vm._v(" "), _c('p', [_vm._v("请复查确保所有购物单据粘在或者钉在了易退税的退税单背后。有效完整的购物单据是进行退税的必要条件。")]), _vm._v(" "), _c('p', [_vm._v("我们将在收到后3-5天进行处理，处理完之后余额将显示在您的易退税APP上，并可以进行提现操作。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99e27b42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Home.vue
// module id = 198
// module chunks = 2